import { render, staticRenderFns } from "./MyForms.vue?vue&type=template&id=de056874&"
import script from "./MyForms.vue?vue&type=script&lang=js&"
export * from "./MyForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports